module.exports = "/_next/static/images/monitoring2-92473fe9cfb9b78eed7641a1cf154819.jpg";